import styles from '../styles/WelcomeCard.module.css'
import Styles2 from '../styles/SuccessOrError.module.css'
import { ImageCard } from './ImageCard'
import {  useEffect, useRef, useState } from 'react'

import Web3Modal from 'web3modal'
import { ethers } from 'ethers'
import { Social } from './Social'
import { ConnectButton } from './ConnectButton'
import { Error } from './Error'
import { useStateValue } from '../context/StateProvider'
import { actionType } from '../context/reducer'
 
export const WelcomeCard = () => {
    
    const web3ModalRef = useRef()
    const [ alertMessage , setAlertMessage ] = useState('');
    const [showAlert, setShowAlert] = useState(false);

    const [{account,user}, dispatch] = useStateValue();
    


    const getSignerOrProvider = async (needSigner = false) => {
        const provider = await web3ModalRef.current.connect();
        const web3Provider = new ethers.providers.Web3Provider(provider);
        const { chainId } = await web3Provider.getNetwork();
        const user1  = await web3Provider.listAccounts();
        
        dispatch({
            type: actionType.SET_USER,
            user: user1[0],
        })
        
        if(chainId !== 4) {
            console.log('not rinkeby',web3Provider)
        };
        if(needSigner) {
            const signer = await web3Provider.getSigner();
            return signer
        };
        return provider;
    };

    const handleConnect = async () => {
        try {
            const response = await getSignerOrProvider()
            console.log(response)
            dispatch({
                type : actionType.SET_ACC,
                account : true
            })
        } catch (error) {
            setShowAlert(true)
            setAlertMessage(`Error: ${error.message}`);
            setTimeout(() => {
                setAlertMessage('')
                setShowAlert(false)
            }, 2000);
        }

    }

    useEffect(() => {
        web3ModalRef.current = new Web3Modal({
            network: "rinkeby",
            providerOptions: {},
            disableInjectedProvider: false,
        });
        console.log(web3ModalRef.current)
    },[])

    return(
    <div className={styles.container}>
        <div>
            <Social/>
            <div className={Styles2.errorfield}>{showAlert && <Error name={alertMessage}/> }</div> 
            <ImageCard />
            <div className={styles.content}>
                <p>Welcome to Matic Vault  </p>
                <p>Explore The Most Safest and Trusted Investment Platform, We are Backed By Blockchain (The Trust Machine), So  We Inherit it Transparency, Speed and Secuirity.You can also Earn Autonomous Referral Commission When You Refer a Friend  </p>
                <p>Connect Your Wallet and Deposit in the Vault to Earn High Yield</p>
            </div>
        </div>
        <ConnectButton onClick={handleConnect} name="Connect Wallet" />
    </div>
    )
}